import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import {isDesktop} from "utils";
import {Route} from "v2/api/Records";

import AdjustDurationsLink from "v2/components/AdjustDurationsLink";
import SendEmailLink from "v2/components/SendEmailLink";

import AddDestinationLink from "v2/components/responsive/AddDestinationLink";
import DeleteRouteLink from "v2/components/responsive/DeleteRouteLink";
import EditRouteLink from "v2/components/responsive/EditRouteLink";
import ReassignRestLink from "v2/components/responsive/ReassignRestLink";
import ReorderDestinationsLink from "v2/components/responsive/ReorderDestinationsLink";

const RouteActionsDropdown = (props, context) => {
  const {params: {date, id, routeId}, routeData, router} = context;
  if (!isDesktop() &&
      id &&
      !router.isActive(`/${date}/${routeId}/${id}`, true)) {
    return null;
  }

  const {style} = props;

  const btnClassName = classnames(
    "dropdown-toggle", "erg-add-link", "NoBoxShadow", props.btnClassName);
  const className = classnames(
    "dropdown", "NoOutlineOnFocus", "RouteActionsDropdown", props.className);
  const printUrl = `${process.env.API_URL}/admin/fieldapp/routes/${routeId}/print/`;
  const readOnly = routeData.readOnly;

  return (
    <div className={className} style={style}>
      <a
        aria-expanded={false}
        aria-haspopup
        className={btnClassName}
        data-toggle="dropdown"
        href="#"
        id="route-actions-dropdown"
        style={{paddingRight: 0}}
        type="button">
        <i className="fa fa-cog" />
        <span
          className="hidden-xs"
          style={{marginRight: "2px"}}>
          Route Actions
        </span>
        <span className="caret hidden-xs" />
      </a>
      <ul
        aria-labelledby="route-actions-dropdown"
        className="dropdown-menu dropdown-menu-right">
        {!readOnly && <AddDestinationLink component="li" />}
        {!readOnly && <ReorderDestinationsLink component="li" data={routeData} />}
        {!readOnly && <EditRouteLink component="li" />}
        {id && !readOnly && <ReassignRestLink component="li" />}

        <li className="divider" role="separator" />
        {!readOnly && <AdjustDurationsLink component="li" />}

        {!readOnly && <li className="divider" role="separator" />}
        <li>
          <a href={printUrl} rel="noopener noreferrer" target="_blank">
            Print
          </a>
        </li>
        <SendEmailLink component="li" />

        {!readOnly && <li className="divider" role="separator" />}
        {!readOnly && <DeleteRouteLink component="li" />}
      </ul>
    </div>
  );
};

RouteActionsDropdown.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string,
    routeId: PropTypes.string.isRequired,
  }),
  routeData: PropTypes.instanceOf(Route).isRequired,
  router: PropTypes.object,
};
RouteActionsDropdown.propTypes = {
  btnClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default RouteActionsDropdown;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteActionsDropdown.js
 **/